module.exports = __webpack_public_path__ + "img/planting.fe81e8ed.jpg";